module.exports = "/assets/0dcf3e449952aa00e5a3e3e3df14decb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SC.png
// module id = 2937
// module chunks = 0